function PageTitle(newTitle, props) {
  if (props.setTitle != null) props.setTitle(newTitle);
}
export default PageTitle;
